<template>
  <div class="event-calendar">
    <div class="mb-3 flex-center-between">
      <v-btn icon @click="Prev" :disabled="isLoading">
        <v-icon>fa-chevron-left</v-icon>
      </v-btn>
      {{ date | toYearMonth }}
      <v-btn icon @click="Next" :disabled="isLoading">
        <v-icon>fa-chevron-right</v-icon>
      </v-btn>
    </div>
    <v-calendar
      ref="calendar"
      v-model="date"
      :events="calendarData"
      @click:event="OnEventClick"
    >
      <template #event="{event}">
        <span :title="event.name">{{ event.name }}</span>
      </template>
    </v-calendar>
    <v-menu
      v-model="selectedOpen"
      :close-on-content-click="false"
      :activator="selectedElement"
      offset-x
    >
      <v-card min-width="350px" max-width="450px" flat>
        <v-toolbar :color="selectedEvent.color" dark>
          <v-btn icon>
            <v-icon>fas fa-calendar-alt</v-icon>
          </v-btn>
          <v-toolbar-title class="pl-0">
            {{ selectedEvent.name }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="selectedOpen = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div
            v-if="selectedEvent.eventType"
            class="font-weight-bold font-size-lg mb-2"
          >
            {{ selectedEvent.eventType }}
          </div>
          <div
            v-if="selectedEvent.start || selectedEvent.end"
            class="font-weight-medium"
          >
            <div v-if="selectedEvent.start" class="d-flex align-center">
              <div class="min-w-70">Kezdete:</div>
              {{ selectedEvent.start | toDateTime }}
            </div>
            <div v-if="selectedEvent.end" class="d-flex align-center">
              <div class="min-w-70">Vége:</div>
              {{ selectedEvent.end | toDateTime }}
            </div>
          </div>
        </v-card-text>
        <v-card-actions v-if="selectedEvent.link">
          <v-btn
            @click="OpenEvent(selectedEvent.link)"
            :color="selectedEvent.color"
            text
          >
            Megnézem
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { groupBy } from 'lodash';
import { EsemenyJelleg } from '../../enums/esemenyJelleg';
import { NotificationFunctions } from '../../functions/NotificationFunctions';
import { esemenyNaptarService } from '../../services/EsemenyNaptarService';
import { timeout } from '../../utils/common';
import { toServerDateTime } from '../../utils/date';
export default {
  name: 'k-event-calendar',
  data() {
    return {
      date: new Date().toISOString(),
      isLoading: false,
      calendarData: [],
      calendarDictionary: {},
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
    };
  },
  mounted() {},
  created() {},
  methods: {
    async GetCalendar() {
      this.isLoading = true;
      try {
        await timeout(1000);
        let result = await esemenyNaptarService.GetCalendar(this.date);
        this.calendarData = result.map(x => ({
          name: x.Nev,
          start: toServerDateTime(x.Kezdete),
          end: toServerDateTime(x.Vege),
          color: x.Jellege?.Id == EsemenyJelleg.Nyilt ? 'blue' : 'green',
          timed: x.Vege != null,
          link: x.Link,
          eventType: x.EsemenyTipusa?.Nev,
        }));
        this.calendarDictionary = groupBy(this.calendarData, e => {
          return toServerDateTime(e.start);
        });
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.isLoading = false;
    },
    Prev() {
      this.$refs.calendar.prev();
    },
    Next() {
      this.$refs.calendar.next();
    },
    OnEventClick(e) {
      const open = () => {
        this.selectedEvent = e.event;
        this.selectedElement = e.nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }
    },
    OpenEvent(link) {
      window.open(link, '_blank');
    },
  },
  computed: {},
  watch: {
    date: {
      handler() {
        this.GetCalendar();
      },
      immediate: true,
    },
  },
};
</script>
